import { NavigationLink } from "components/base/base";

export const LeftButtons = () => (
  <div className="space-x-6">
    <NavigationLink title="Orders" to="/amazon/orders" />
    <NavigationLink title="Warehouses" to="/amazon/warehouses" />
  </div>
);
